import httpClient from '@/http-client'

export const userGroup = (Options = {}) => {
  return httpClient
    .get('/api/v1/location-tracking-remarks/user-groups', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const get = data => {
  return httpClient
    .post('/api/v1/location-tracking-remarks/list', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/v1/location-tracking-remarks', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const exportExcel = data => {
  return httpClient
    .post('/api/v1/location-tracking-remarks/excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  store,
  userGroup,
  exportExcel
}
